import { retry } from '@color/lib';

export async function polyfillDateTimeFormatTimezone() {
  if (!window.Intl?.DateTimeFormat) {
    // This is about 2.85 MiB
    await retry(() => import('date-time-format-timezone'));
  }
}
